(function () {
    'use strict';

    var serviceId = 'historyService';

    angular.module('app.common')
        .factory(serviceId, [
            'history_factory',
            'history_factory_v3',
            'userSvc', 
            '$location', 
            '$q', 
            'geoApi',
            'agentApi',
            '$window',
            '$rootScope',
            'projectsApi',
            'mallsAPI',
            'opportListAPI',
            'valuationGETAPI',
            historyService
        ]);

    function historyService(
        history_factory,
        history_factory_v3,
        userSvc, 
        $location, 
        $q, 
        geoApi,
        agentApi,
        $window,
        $rootScope,
        projectsApi,
        mallsAPI,
        opportListAPI,
        valuationGETAPI
    ) {
        var service = {
            set: set,
            get: get,
            getGeoNames: getGeoNames,
            getAgents: getAgents,
            getProjects: getProjects,
            getMalls: getMalls,
            getOpportunities: getOpportunities,
            getValuations: getValuations,
            getAnalyses: getAnalyses,
            historyObj: {
                agent: [],
                project: [],
                opportunity: [],
                mall: [],
                valuation: [],
                analyse: []
            }
        };

        return service;

        function prepareHistory (history) {
            service.historyObj = {
                agent: [],
                project: [],
                opportunity: [],
                mall: [],
                valuation: [],
                analyse: []
            };
              angular.forEach(history, function (h) {
                switch (h.screenName) {
                  case 'agent':
                    let existingAgent = service.historyObj.agent.find(a => a.agentId === h.agentId);
                    if (!existingAgent)
                        service.historyObj.agent.push(h);
                    break;
                  case 'project':
                    let existingProject = service.historyObj.project.find(p => p.projectId === h.projectId);
                    if (!existingProject) {
                        service.historyObj.project.push(h);
                    }
                    break;
                  case 'opportunity':
                    let existingOpportunity = service.historyObj.opportunity.find(o => o.opportunityId === h.opportunityId);
                    if (!existingOpportunity) {
                        service.historyObj.opportunity.push(h);
                    }
                    break;
                  case 'mall':
                    let existingMall = service.historyObj.mall.find(m => m.mallId === h.mallId);
                    if (!existingMall)
                        service.historyObj.mall.push(h);
                    break;
                  case 'valuation':
                      if (service.historyObj.valuation.indexOf(h.valuationId) === -1)
                        service.historyObj.valuation.push(h);
                      break;
                  default:
                    service.historyObj.analyse.push(h);
                }
            });
        }

        function getAgents(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.agent.length) {
                let AgentIds = service.historyObj.agent.map(a => a.agentId);
                agentApi.agentsById({
                  CategoryId: 0,
                  Language: $window.langCode($rootScope.lang),
                  AgentIds: limit ? AgentIds.slice(0, limit) : AgentIds
                }).$promise.then( function (result) {
                    let agents = result.Results.map(a => {
                        a.UpdateDate = service.historyObj.agent.find(h => h.agentId === a.Id).createDate;
                        return a;
                    })
                  deferred.resolve(agents);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
            }
            return deferred.promise;
        }

        function getProjects(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.project.length) {
                let HousingProjectIds = service.historyObj.project.map(p => p.projectId);
                projectsApi.projectsById({
                  HousingProjectIds: limit ? HousingProjectIds.slice(0, limit) : HousingProjectIds
                }).$promise.then( function (result) {
                    let projects = result.Data.map(p => {
                        p.UpdateDate = service.historyObj.project.find(h => h.projectId === p.Id).createDate;
                        return p;
                    })
                  deferred.resolve(projects);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getMalls(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.mall.length) {
                let ShoppingCenterIds = service.historyObj.mall.map(m => m.mallId);
                mallsAPI.mallsById({
                  ShoppingCenterIds: limit ? ShoppingCenterIds.slice(0, limit) : ShoppingCenterIds
                }).$promise.then( function (result) {
                    let malls = result.Data.map( m => {
                        m.UpdateDate = service.historyObj.mall.find(h => h.mallId === m.Id).createDate;
                        return m;
                    })
                  deferred.resolve(malls);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getOpportunities(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.opportunity.length) {
                let PortfolioIds = service.historyObj.opportunity.map(o => o.opportunityId);
                opportListAPI.opportsById({
                  PortfolioIds: limit ? PortfolioIds.slice(0, limit) : PortfolioIds,
                  Language: $window.langCode($rootScope.lang)
                }).$promise.then( function (result) {
                    let opportunities = result.OpportunityList.map(o => {
                        o.UpdateDate = service.historyObj.opportunity.find(h => h.opportunityId === o.PortfolioId).createDate;
                        return o;
                    })
                  deferred.resolve(opportunities);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getValuations(limit = 0) {
            var deferred = $q.defer();
            if (service.historyObj.valuation.length) {
                let valuationIds = service.historyObj.valuation.map(v => v.valuationId);
                valuationGETAPI.valuationsById({
                  valuationIds: limit ?  valuationIds.slice(0, limit) :  valuationIds,
                  Language: $window.langCode($rootScope.lang)
                }).$promise.then( function (result) {   
                   let valuations = result.Properties.map(v => {
                        v.FinalValuation.CreateDate = service.historyObj.valuation.find(h => h.valuationId === v.Id).createDate;
                        return v;
                    }); 
                  deferred.resolve(valuations);
                }, function (err) {
                    deferred.reject(err.data.detail);
                })
              }
              return deferred.promise;
        }

        function getAnalyses(limit = 0) {
            return limit ? service.historyObj.analyse.slice(0, limit) : service.historyObj.analyse
        }

        function get(payload) {
            var deferred = $q.defer();
            history_factory_v3.get(payload).$promise.then(function (result) {
                if (result.length)
                    prepareHistory(result);
                else deferred.reject();
                deferred.resolve(service.historyObj);
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

        function set(screenName, id, geo) {
            if (window.isHeadless())
                return false;
            var projectId, agentId, opportunityId, mallId, valuationId;
            switch (screenName) {
                case 'project':
                    projectId = id;
                    break;
                case 'agent':
                    agentId = id;
                    break;
                case 'opportunity':
                    opportunityId = id;
                    break;
                case 'mall':
                    mallId = id;
                    break;
                case 'valuation':
                    valuationId = id;
                    break;
                default:
                    break;
            }

            var geoInfo = undefined;
            if (geo) {
                geoInfo = {
                    latitude: geo.latitude,
                    longitude: geo.longitude,
                    countryId: geo.CountryId,
                    cityId: geo.CityId,
                    countyId: geo.CountyId,
                    districtId: geo.DistrictId,
                    level: geo.level
                };
            }

            userSvc.getFinger().then(function (finger) {
                var data = {
                    fingerPrint: finger,
                    url: $location.absUrl(),
                    screenName: screenName,
                    valuationId: valuationId,
                    agentId: agentId,
                    opportunityId: opportunityId,
                    projectId: projectId,
                    mallId: mallId,
                    geoInfo: geoInfo
                };

                if (userSvc.info.Id) data.userId = userSvc.info.Id;

                history_factory.set(data);
            });
        }

        function getGeoNames (geoInfo) {
            var defer = $q.defer();
            geoApi.getNamesByCountryId({countryId: geoInfo.countryId}).$promise.then(function (result) {
              let cityObj = result.Cities.find((c) => c.CityId === geoInfo.cityId);
              let countyObj = cityObj && cityObj.Counties.find((c) => c.CountyId === geoInfo.countyId);
              let districtObj = countyObj && countyObj.Districts.find((c) => c.DistrictId === geoInfo.districtId);

              geoInfo = Object.assign(geoInfo, {
                country: result.Name, 
                city: cityObj && cityObj.Name,
                county: countyObj && countyObj.Name, 
                district: districtObj && districtObj.Name, 
              });
        
              defer.resolve();
            }, function () {
                defer.reject();
            });

            return defer.promise;
          }

    }
})();